import { Row, Col, Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import AdminModal from './AdminModal';

const InformationModal = ({

    onSubmit = () => { },
    onChange = () => { },
    setModalShow = () => { },
    cancelModal = () => { },
    modalStyle = {
        backgroundColor: "#f5fcf9",
        borderTopColor: "#7991d4"
    },
    modalShow = null,
    title = "新增題目",
    comfirmButtonColor = "#ccc",
    value = null,
    treeNode,
    ...props
}) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [columnRequires, setColumnRequires] = useState([])
    const [form] = Form.useForm();
    const [file_id, setFileId] = useState([])

    const onFinish = (values) => {
        if (props.edit) {
            // onChange(treeNode, values.name)
            onChange(treeNode, values)
        }
        else {
            onSubmit(values, treeNode)
        }

        setModalOpen(false)
        setModalShow(false)
        form.resetFields()
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        setModalShow(false)

    };
    const cancel = () => {
        // console.log("cancel")
        setModalOpen(false)
        setModalShow(false)
        cancelModal()
        form.resetFields()
    }


    const handleEdit = (file_id) => {
        setFileId(file_id)
        form.submit()
    }
    const handleSubmit = (file_id) => {
        setFileId(file_id)
        form.submit()
    }

    useEffect(() => {
        form.setFieldsValue(value)
    }, [value])

    return (<>
        <AdminModal
            {...props}
            open={modalShow !== null ? modalShow : modalOpen}
            cancel={cancel}
            editcard={{}}
            title={(<>
                <Col
                    style={{
                        fontWeight: 'bold',
                        fontSize: '20px',
                        position: 'absolute',
                        zIndex: 99,
                        top: 53,
                        left: 32
                    }} >
                    {title}
                </Col>

            </>)}
            modalStyle={
                modalStyle
            }
            // uploads_text="參考答案之檔案檔名"
            uploads={false}
            handleSubmit={handleSubmit}
            handleEdit={handleEdit}
        >
            <Row gutter={[8, 8]} align={'middle'}>
                <Col span={24}>
                    <Form
                        form={form}
                        name="treeModal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label={"名稱"}
                            name="name"
                            rules={[
                                {
                                    required: columnRequires.includes("name"),
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            <Input>
                            </Input>
                        </Form.Item>
                        {props.formItemsRender && props.formItemsRender()}
                    </Form>
                </Col>
            </Row>
        </AdminModal >
    </>)

}
export default InformationModal;
